import React, { useState } from 'react';
import DebounceTextInput from 'components/DebounseTextInput';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { Col, Row } from 'reactstrap';
import AllCategoryTable from './components/AllCategoryTable';
// import AdvancedFilters from 'components/AdvancedFilters';
// import CategoryFilter from 'pages/Products/components/CategoryTab/components/CategoryFilter';

// const initialValues = {
//   category: null,
// };
const AllCategory = ({
  toggleDeleteRecord,
  handleClickEdit,
  toggleAddRecord,
}) => {
  const [searchString, setSearchString] = useState('');
  // const [filterValue, setFilterValue] = useState([]);
  // const statusFilter = {
  //   key: 'status',
  //   value: 'ALL',
  //   type: 'STRING',
  //   op: 'EQ',
  // };

  // const handleFilters = (val) => {
  //   setFilterValue([
  //     {
  //       key: 'name',
  //       value: val?.category?.name ? val?.category?.name : '',
  //       type: 'STRING',
  //       op: 'LIKE',
  //     },
  //   ]);
  // };

  const handleChange = (value) => {
    setSearchString(value);
  };

  return (
    <div>
      {' '}
      <ErrorBoundary>
        <div className="products-toolbar">
          <Row>
            {/* <Col sm={6}>
            <AdvancedFilters
              handleFilters={handleFilters}
              initialValues={initialValues}
              id="category_all"
            >
              <CategoryFilter statusFilter={statusFilter} />
            </AdvancedFilters>
          </Col> */}
            <Col sm={6} className="text-end">
              <DebounceTextInput
                onInputChange={handleChange}
                delay={500} // Set your desired delay in milliseconds
                value={searchString}
                placeholder="Search by category"
                positionTop="-52px"
                positionRight="95px"
                classWrapper="products-search"
              />
            </Col>
          </Row>
          <AllCategoryTable
            searchString={searchString}
            handleClickEdit={handleClickEdit}
            toggleDeleteRecord={toggleDeleteRecord}
            toggleAddRecord={toggleAddRecord}
          />
        </div>
      </ErrorBoundary>
    </div>
  );
};

export default AllCategory;
